import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";

import LandingPage from "./pages/LandingPage";
import ReportPage from "./pages/ReportPage";
import ReportSuccessPage from "./pages/ReportSuccessPage";
import TrackPage from "./pages/TrackPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminReportDetailPage from "./pages/AdminReportDetailPage";
import ProtectedRoute from "./components/ProtectedRoute";
import PwaInstallButton from "./components/PwaInstallButton";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/lapor" element={<ReportPage />} />
            <Route path="/lapor/sukses/:nomor" element={<ReportSuccessPage />} />
            <Route path="/lacak" element={<TrackPage />} />

            {/* Admin routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboardPage />} />
              <Route path="laporan" element={<AdminDashboardPage />} />
              <Route path="laporan/:id" element={<AdminReportDetailPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
          <PwaInstallButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
